import { makeAutoObservable, runInAction } from 'mobx';

import { IntermediaryApi } from './intermediary.api';
import { ContactHfsDto, InviteCustomerDto } from './intermediary.dto';

class IntermediaryStore {
  intermediaryApi: IntermediaryApi;

  isLoading = false;

  isInviteCustomerInProgress = false;

  constructor() {
    this.intermediaryApi = new IntermediaryApi();
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async contactHfs(contactHfsDto: ContactHfsDto) {
    this.isLoading = true;

    try {
      await this.intermediaryApi.contactHfs(contactHfsDto);
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  async inviteCustomer(inviteCustomerDto: InviteCustomerDto) {
    this.isInviteCustomerInProgress = true;

    try {
      await this.intermediaryApi.inviteCustomer(inviteCustomerDto);
    } finally {
      runInAction(() => {
        this.isInviteCustomerInProgress = false;
      });
    }
  }

  async scheduleMeeting() {
    await this.intermediaryApi.scheduleMeeting();
  }
}

export default IntermediaryStore;
